import axios from '@/plugin/axios'
import api from '@/api'

export const customer = {
  searchByCustomer,
  searchByMdmId
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data)
    }).catch(e => {
      if (e.code === 404 && e.message === 'Not Found') resolve([] as any)
      else reject(e)
    })
  })
}

function searchByCustomer(searchBy: string, name: string): Promise<any> {
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.SEARCH_CUSTOMER, {
    params: {
      searchBy: searchBy.toUpperCase(),
      name: name.toUpperCase()
    }
  }))
}

function searchByMdmId(mdmId: string): Promise<any> {
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.SEARCH_SERIAL_NUMBER.replace('{mdmId}', mdmId)))
}
